import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-info',
  templateUrl: './about.component.html',
  styleUrls: ['../../../app.component.scss', './about.component.scss']
})
export class AboutComponent implements OnInit {
  VERSION = environment.VERSION;
  constructor() { }

  ngOnInit() {
  }

}
